import React from 'react';
import { Calendar, MapPin, ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { heroContent, companyInfo } from '../data/mock';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center pt-24 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroContent.heroImage}
          alt="Kaaba Mecca"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-[#F5C842]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-[#8B0000]/10 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-[#F5C842]/20 backdrop-blur-md border border-[#F5C842]/30 rounded-full px-6 py-2 mb-6 animate-fade-in">
            <Sparkles className="w-4 h-4 text-[#F5C842]" />
            <span className="text-sm font-medium text-white">Paket Special Ramadhan 2026</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            <span className="text-[#F5C842]">{heroContent.title}</span>
            <br />
            <span className="text-3xl md:text-4xl font-normal text-white/90">
              {heroContent.subtitle}
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            {heroContent.description}
          </p>

          {/* Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center space-x-3 mb-2">
                <Calendar className="w-5 h-5 text-[#F5C842]" />
                <span className="text-sm text-white/80">Keberangkatan</span>
              </div>
              <p className="text-2xl font-bold text-white">{heroContent.departureDate}</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center space-x-3 mb-2">
                <MapPin className="w-5 h-5 text-[#F5C842]" />
                <span className="text-sm text-white/80">{heroContent.priceLabel}</span>
              </div>
              <p className="text-3xl font-bold text-[#F5C842]">{heroContent.price}</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a href={`https://wa.me/${companyInfo.whatsapp}?text=Assalamualaikum, saya tertarik dengan paket ${heroContent.title}`} target="_blank" rel="noopener noreferrer">
              <Button 
                size="lg" 
                className="w-full sm:w-auto bg-[#8B0000] hover:bg-[#A52A2A] text-white text-lg px-8 py-6 shadow-2xl hover:shadow-[#8B0000]/50 transition-all duration-300 hover:scale-105"
              >
                Daftar Sekarang
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </a>
            <a href="#packages">
              <Button 
                size="lg" 
                variant="outline"
                className="w-full sm:w-auto bg-white/10 backdrop-blur-md border-2 border-white text-white hover:bg-white hover:text-[#8B0000] text-lg px-8 py-6 transition-all duration-300"
              >
                Lihat Paket Lainnya
              </Button>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center gap-6 mt-12 pt-8 border-t border-white/20">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-[#F5C842] rounded-full"></div>
              <span className="text-white/80 text-sm">Terdaftar Resmi Kemenag</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-[#F5C842] rounded-full"></div>
              <span className="text-white/80 text-sm">Berpengalaman 10+ Tahun</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-[#F5C842] rounded-full"></div>
              <span className="text-white/80 text-sm">1000+ Jamaah Terlayani</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
